import { useSelector } from "react-redux";

import { IStore } from "../interfaces/IStore";
import { ITradeInfoState } from "../interfaces/ITradeInfo";

export const getTradeInfo = (state: IStore): ITradeInfoState => state.trade;

export const useTradeInfo = (): ITradeInfoState => useSelector(getTradeInfo);
